import React, { useState } from "react";
import { FormControl, InputLabel, MenuItem } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import globalClasses from "../css/Global.module.css";

const SelectField = (props: any) => {
  const [dropdownValue, setDropdownValue] = useState("");

  const handleChangeDropdown = (event: SelectChangeEvent) => {
    setDropdownValue(event.target.value);
  };
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 224,
        width: "auto",
      },
    },
  };
  return (
    <FormControl fullWidth size="small" variant="outlined">
      <InputLabel
        htmlFor={props.id}
        className={`${props.isrequired && globalClasses.dropdownAsterisk} ${
          props.error && globalClasses.dropdownErrorLabel
        }`}
      >
        {props.headerText}
      </InputLabel>
      <Select
        fullWidth
        id={props.id}
        size={props.size ? props.size : "small"}
        label={props.label}
        name={props.name}
        value={props.value ? props.value : dropdownValue}
        onChange={props.changeevent ? props.changeevent : handleChangeDropdown}
        onBlur={props.blurevent}
        MenuProps={MenuProps}
        disabled={props.disable}
        defaultValue={props.defaultValue}
        error={props.error}
        onClick={props.clickevent}
        required={props.isrequired ? props.isrequired : false}
        sx={props.selectSx}
        inputProps={{ id: props.id }}
      >
        {props.list
          ? props.list
          : props.options.map((option: any) => {
              return (
                <MenuItem
                  key={option?.id ? option?.id : option?.eliId}
                  value={option?.value ? option?.value : option?.eliText}
                >
                  {option?.value ? option?.value : option?.eliText}
                </MenuItem>
              );
            })}
      </Select>
    </FormControl>
  );
};

export default SelectField;
